<template>
  <div class="nerbyU relative" id="section_V">
    <div class="absolute show-desktop">
      <img class="img-responsive" src="@/assets/home/elderly.png" alt="elderly" />
    </div>
    <a id="unidades"></a>
    <div class="container section-V relative">
      <div class="content">
        <div class="row">
          <div class="col-md-10 offset-md-2 row">
            <div class="col-md-6 flex j-c-center relative show-desktop dotted-map">
              <img
                class="img-responsive"
                src="@/assets/home/dotted-map.png"
                alt="dotted-map"
              />
            </div>       
            <div class="col-lg-6 offset-lg-0 col-md-6 offset-md-8">
              <h3 class="little-title toUpperCase color-white">unidades</h3>
              <h2 class="big-title title-between color-white">
                Descubra a Ponto Fácil mais perto de você.
              </h2>
              <div class="selectState">
                <div class="row camp-select">
                  
                  <div class="col-md-6 state-city selecting-state no-padding">
                  <label>Estados</label>
                    <div class="btn-select relative" >
                      <select
                        v-model="selectedState"                        
                        class="mdb-select md-form" 
                        id="selectStateTwo"
                      >
                        
                        <option value="Todos">Todos</option>
                        <option v-for="(state, index)  in states" 
                        :key="index"     
                        >
                        {{ state.uf }}                    
                        </option>
                      </select>
                    </div>
                  </div>
                 
                  <div class="col-md-6 state-city no-padding">
                  <label>Cidades</label>
                    <div class="btn-select relative" id="selectCity">                    
                      <select class="SelectCty" v-model="selectedCity" name="same">
                        <option value="Todos">Todos</option>
                        <option v-for="(city, index) in resultCities.cities"   
                          :key="index"   
                          :value="city.nameCity"                                  
                        >
                          {{ city.nameCity }}                         
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 no-padding btn-search offset-md-6">
                    <span @click="show()">
                      <div
                        class="bg-color-F38235 btn-height mt-3 flex j-c-center relative"
                      >
                        <span class="f-w-700 color-white" type="reset">Pesquisar</span>
                      </div>
                      <div class="icon-search icon-search-ajust-main color-white">
                        <img
                          class="img-responsive"
                          src="@/assets/home/icons/icon-search.png"
                          alt="icon-search"
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block d-sm-none elderly">
        <img class="img-responsive" src="@/assets/home/elderly.png" alt="elderly" />
      </div>
    </div>
    <modal
      name="modalSearch"
      class="relative"
      id="modal"
      :height="'75%'"
      :width="modal_width"
    >
      <div class="modal-header">
        <div class="absolute icon-close" @click="hide()">
          <img
            class="img-responsive"
            id="icon-close-modal"
            src="@/assets/home/icons/icon-close.png"
            alt="Icon-close"
          />
        </div>
        <div class="flex j-c-center">
          <div class="logo">
            <img
              class="img-responsive"
              src="@/assets/logoBrancaHorizontal.png"
              alt="logoAzulHorizontal"
            />
          </div>
        </div>
      </div>
      <div class="searching-modal">
        <div class="selecting-modal">
          <div class="row camp-select">
            <div class="col-md-4 state-city">
              <label>Estados</label>
              <div class="btn-select relative" >
                <select
                  class="mdb-select md-form"
                  v-model="selectedState"
                  id="selectStateTwo"
                >
                  
                  <option value="Todos">Todos</option>
                  <option v-for="(state, index)  in states" 
                    :key="index"     
                    >
                    {{ state.uf }}                    
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-4 state-city selecting-city">
              <label>Cidades</label>
              <div class="btn-select relative" id="selectCity">
                <select class="SelectCty" v-model="selectedCity" name="same">
                  
                  <option value="Todos">Todos</option>
                 <option v-for="(city, index) in resultCities.cities"   
                    :key="index"   
                    :value="city.nameCity"                                  
                    >
                    {{ city.nameCity }}                         
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4 btn-search modalSearching relative">
              <span @click="show()">
                <div
                  class="bg-color-F38235 btn-height flex j-c-center relative btn-search-modal"
                >
                  <span class="f-w-700 color-white">Pesquisar</span>
                </div>
                <div class="icon-search color-white">
                  <img
                    class="img-responsive"
                    src="@/assets/home/icons/icon-search.png"
                    alt="icon-search"
                  />
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- {{pontoNearby}} -->
      <div class="modal-content">
        <div class="pontoNearby container">
          <div class="row" id="ponto-father">
            <div
              
              v-for="(item, index) in pontoNearby"
              :key="index"
             
            > 
              <div class="bordering" :id="'bordering' + index"
              >
                <strong class="color-blue">{{ item.city}}</strong
                ><br />
                <small class="color-blue">{{ item.email}}</small>
                <div class="a-address">
                  <a :href="`//www.google.com/maps/search/?api=1&query=${item.address}`" target="_blank" rel="noopener noreferrer"
                    ><p>{{ item.address }}</p></a
                  >
                  <p>{{ item.city }}/{{ item.state }}</p>
                  <p>{{ item.cellphone }}</p>
                  <p>{{ item.socialMedial }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </modal>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/jszip.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.js"></script>
<script
  type="text/javascript"
  src="https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"
></script>

<script>
import $ from "jquery";
import HTTP from '../services/config';
export default {
  data() {
    return {
      pontoNearby: [],
      modal_width: 0,
      selectedState: "Todos",
      selectedCity: "Todos",
      states: [],
      cities: [],
      tenantCards: [],
    };
  },
  mounted() {
    this.getNearby()
  },

  created() {
    let that = this;
    if ($(window).width() <= 768) {
      that.modal_width += "80%";
    } else {
      that.modal_width += "50%";
    }
  },
  methods: {
      
      getCities(uf){
        if(this.cities.length === uf){
        return this.cities.filter((x) => x.uf)
      }
      },
      getNearby(){
        return HTTP.get('services/app/Tenant/GetAllTenantCards')
        .then((res) => {
          
          let getContainer = res.data.result
            this.states = getContainer.cityStates.map((data) => ({uf: data.uf}))
            this.cities = getContainer.cityStates.map((data) => ({cities: data.cities.map((city)=>({nameCity: city.nameCity, uf: city.ufCity})

          )}))
          this.tenantCards = getContainer.tenantCards  
        })
      },
     

    show() {
        this.$modal.show("modalSearch");
        this.filterCity()   
    },
    filterCity() {
      const { selectedState, selectedCity, tenantCards } = this

      if(selectedState === "Todos" && selectedCity === "Todos") {
        this.pontoNearby = tenantCards
        return
      }else if(selectedState === "Todos" && selectedCity !== "Todos"){
        this.pontoNearby = tenantCards.filter(item => selectedCity === item.city)
        return
      }

      const currentState = tenantCards.filter(item => selectedState === item.state) // filtrar os estados e retornar

      if (selectedCity !== 'Todos') { // se selecionar uma cidade 
        const currentCity = currentState.filter(item => selectedCity === item.city) // filtrar e retornar a cidade
        this.pontoNearby = currentCity
        return
      }
      this.pontoNearby = currentState
    },
    hide() {
      this.$modal.hide("modalSearch");
    },
    LetsToggle(LetsToggle, chevronState) {
      $(LetsToggle).toggle("fast", function () {
        $(chevronState).toggleClass("rotate");
      });
    },
    processData(csv) {
      var allTextLines = csv.split(/\r\n|\n/);
      var lines = [];
      for (var i = 0; i < allTextLines.length; i++) {
        var data = allTextLines[i].split(";");
        var tarr = [];
        for (var j = 0; j < data.length; j++) {
          var dataToSplit = data[j].replaceAll(",,", ";");
          var data2 = dataToSplit.split(",");
          tarr.push(data2);
        }
        lines.push(tarr);
      }
    },
    
  },
  computed: {
    resultCities(){
      if(this.selectedState != "" && this.selectedState != "Todos"){
        let city = this.cities.find((x) => x.cities.every((data) => data.uf == this.selectedState));
        return city;

      }else if(this.selectedState == "Todos"){
        let city = {
          cities: []
        };
        this.cities.forEach(indexCity => {
          indexCity.cities.forEach(indexInter => {
            city.cities.push(indexInter);
          });
        });
        return city;
      }
      else{
        return [];
      }
    },
    
  },
  watch: {
    selectedState:function(){
      this.selectCity = "";
    },
  }
};
</script>
<style scoped>
.btn-height {
  margin-top: -5px;
}

.col-md-6 {
  padding: 0 10px;
}

option {
  font-size: 12px;
}

.elderly img {
  margin-bottom: -30px;
}

#section_V {
  position: relative;
  background-color: #175d93;
}

#section_V .absolute {
  bottom: 0;
}

#section_V .absolute img {
  width: 500px;
}

.card-body::-webkit-scrollbar-thumb:vertical {
  height: 10px;
}

.dotted-map img {
  width: 90%;
}

#section_V .content {
  padding: 75px 0;
}

#section_V h2,
#section_V h3 {
  font-weight: 700;
}

#section_V label {
  font-size: 12px;
  top: -25px !important;
  color: #fff;
  font-weight: 700;
}

#section_V .title-between {
  margin: 35px 0 50px 0;
}

button {
  border: none;
  background-color: transparent;
  width: 100%;
  padding: 0;
}

.btn-select:hover,
.btn-select:focus {
  cursor: pointer;
}

.btn-search:hover span {
  cursor: pointer;
}

/*Modal*/
div >>> .v--modal-box.v--modal {
  border: 3px solid #fff;
  border-bottom: none;
  position: relative;
  overflow: visible;
  /* overflow: scroll; */
}

.icon-close {
  right: -5px;
  top: -30px !important;
  width: 0px !important;
}

.icon-close:hover {
  cursor: pointer;
}
#selectStateTwo{
  height: 80%;
}

.icon-close img {
  width: 35px !important;
}

/* div >>> .v--modal-box.v--modal{
        overflow: hidden;
    } */

div >>> .modal-content {
  width: 100%;
  overflow-y: scroll;
  height: 60%;
  border-bottom: none;
}

div >>> .modal-content::-webkit-scrollbar-track {
  background: #175d93;
}

div >>> .modal-content::-webkit-scrollbar-thumb {
  background: #e0a638;
}

div >>> .v--modal-overlay {
  background: rgba(0, 0, 0, 0.75);
}

.modal-header {
  background-color: #357eb8;
  border: none;
}

.modal-header > div {
  width: 100%;
}

.btn-search-modal {
  margin-top: 0;
}

.selecting-modal {
  padding: 20px 50px 20px 50px;
  background-color: #357eb8;
}

select,
.optionsCitys {
  min-width: 100%;
  padding-left: 15px;
  font-size: 12px !important;
}
.SelectCty{
  height: 80%;
}

.logo img {
  width: 150px;
}

.pontoNearby {
  width: 100%;
}

.pontoNearby p {
  font-size: 12px;
  margin: 0;
}

.a-address {
  margin: 20px 0 0 0;
}

.bordering {
  padding: 20px 20px 0 20px;
  min-width: 350px;
  max-width: 350px;
  width: 100%;
}

.modalSearching .icon-search {
  top: -20px;
}
.modalSearching{
  margin-top: 29px;
}

.icon-search-ajust-main {
  top: -5px;
}

@media only screen and (max-width: 1025px) {
  .modal-content {
    height: 79% !important;
  }
}

@media only screen and (max-width: 992px) {
  .dotted-map {
    background-color: red;
  }
  .dotted-map img {
    position: absolute;
    width: 350px;
    top: 0;
    transform: translate(-30%, 20%);
  }
  #section_V .absolute img {
    width: 400px !important;
  }

  #section_V .absolute #icon-close-modal {
    width: 35px !important;
  }
}

@media only screen and (max-width: 768px) {
  .modal-content {
    height: 72% !important;
  }
}

@media only screen and (max-width: 767px) {
  #section_V .title-between {
    margin: 35px 0 60px 0;
  }

  .modal-header {
    display: none;
  }

  label {
    font-size: 14px !important;
  }

  .elderly img {
    width: 300px;
  }

  #section_V .content {
    padding: 50px 0 0 0;
  }

  .btn-search span {
    font-size: 16px;
  }

  .section-V {
    padding: 0 40px;
  }

  .selecting-modal {
    padding: 20px 10px;
  }

  /* .selecting-city{
                margin: 0 0 15px 0;
            } */

  .modal-content {
    height: 57.4% !important;
  }

  .logo {
    padding: 10px 0;
  }

  /* .btn-search{
            margin-top: 15px;
        } */
}

@media only screen and (max-width: 430px) {
  .modal-content {
    height: 56% !important;
  }
}

@media only screen and (max-width: 375px) {
  .modal-content {
    height: 53% !important;
  }
}

@media only screen and (max-width: 360px) {
  .modal-content {
    height: 50% !important;
  }
}

@media only screen and (max-width: 320px) {
  .modal-content {
    height: 34% !important;
  }
}

/*Modal*/
</style>
